import { AppRoute } from '../../enums';
import { AuthenticationFacade } from '../auth';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { inject } from '@angular/core';
import { map } from 'rxjs/operators';

export const authGuard: CanActivateFn = (): Observable<UrlTree | boolean> => {
  const authService = inject(AuthenticationFacade);
  const navigation = inject(Router);

  return authService.authenticationChange$.pipe(
    map((isAuthenticated: boolean) => {
      if (!isAuthenticated) {
        return navigation.parseUrl(AppRoute.Login);
      }

      return isAuthenticated;
    }),
  );
};
